export const getvwcd2plmd00100 = (state) => {
  console.log('vwcd2plmd00100', state)
  return state.temp_vwcd2plmd00100
}
export const getvwcd2plmd00101 = (state) => {
  console.log('vwcd2plmd00101', state)
  return state.temp_vwcd2plmd00101
}
export const getvwcd2plmd00102 = (state) => {
  console.log('vwcd2plmd00102', state)
  return state.temp_vwcd2plmd00102
}
